<template>
  <div>刷新</div>
</template>

<script>
export default {
  name: 'CommonRefresh',
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.$router.replace({
        path: from.fullPath,
      })
    })
  },
  data() {
    return {
      from: {},
    }
  },
}
</script>
